import React, { useEffect, useState, useContext } from "react";

import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { base_path_img } from "../../environment";

import { PlusCircle } from "react-feather";
import { ArrowLeft } from "lucide-react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Table, Image, Modal, Select, Tag, Button, Spin, Empty } from "antd";
import AddUsers from "../../core/modals/usermanagement/addusers";
import EditUser from "../../core/modals/usermanagement/edituser";
import { deleteUser } from "../../service/ApiServices";
import { fetchAllUsers, toggleLoginAccess, getLoginAccessHistory } from "../../service/userService";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";
import ViewUser from "../../core/modals/usermanagement/viewuser";

const Users = () => {
  const { user } = useContext(UserContext);
  const [userData, setUserData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewUserId, setViewUserId] = useState(null);
  const [updateUser, setUpdateUser] = useState(null);
  const [search, setSearch] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false);
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize);
  const pageSizeOptions = [5, 10, 20, 50, 100];
  // console.log(userData, "USER DATA ==== user.jsx")

  // Login Access History modal state
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyUserName, setHistoryUserName] = useState("");

  const handleUpdateUser = (record) => {
    setUpdateUser(record);
    setOpenEdit(true);
  };
  const handleClose = () => {
    setUpdateUser(null);
    setOpenEdit(false);
  };
  const handleViewUser = (record) => {
    setViewUserId(record._id);
    setOpenView(true);
  };
  const handleCloseView = () => {
    setViewUserId(null);
    setOpenView(false);
  };
  const getUsers = async () => {
    try {
      setLoading(true); // Start loading
      const userData = await fetchAllUsers(); // Fetch user data
      setUsers(userData); // Update state with the fetched data
    } catch (error) {
      console.error("Error fetching users:", error); // Log any errors
    } finally {
      setLoading(false); // Stop loading regardless of success or error
    }
  };
  useEffect(() => {
    getUsers(); // Call the getUsers function
  }, []); // Empty dependency array ensures it runs once when the component mounts

  //delete user

  const deleteUserData = async (record) => {
    try {
      // console.log(record.key,"RECORD user.jsx")
      await deleteUser(record);
      const updatedUserData = userData.filter((user) => user !== record);
      // showConfirmationAlert(record);
      setUserData(updatedUserData);
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  // Toggle Login Access
  const handleToggleLoginAccess = (record) => {
    const isCurrentlyEnabled = record.loginAccess !== false;
    const MySwal = withReactContent(Swal);

    if (isCurrentlyEnabled) {
      // DISABLE — require reason
      MySwal.fire({
        title: "Disable Login Access",
        html: `<p>Are you sure you want to <strong>disable</strong> login access for <strong>${record.name || "this user"}</strong>?</p>
               <p style="margin-top:10px;font-size:13px;color:#666;">This will prevent the user from logging into the system.</p>`,
        input: "textarea",
        inputLabel: "Reason (required)",
        inputPlaceholder: "Enter the reason for disabling login access...",
        inputAttributes: {
          "aria-label": "Reason for disabling login access",
        },
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return "Reason is required when disabling login access";
          }
        },
        showCancelButton: true,
        confirmButtonColor: "#ff4d4f",
        cancelButtonColor: "#d9d9d9",
        confirmButtonText: "Disable Access",
        cancelButtonText: "Cancel",
        icon: "warning",
      }).then(async (result) => {
        if (result.isConfirmed && result.value) {
          try {
            await toggleLoginAccess(
              record._id,
              false,
              result.value,
              user?.data?._id || user?._id || null,
              user?.data?.name || user?.name || "Unknown"
            );
            MySwal.fire({
              title: "Disabled!",
              text: `Login access has been disabled for ${record.name || "this user"}.`,
              icon: "success",
              confirmButtonText: "OK",
              confirmButtonColor: "#28a745",
            });
            getUsers(); // Refresh
          } catch (error) {
            MySwal.fire({
              title: "Error",
              text: error.message || "Failed to disable login access",
              icon: "error",
            });
          }
        }
      });
    } else {
      // ENABLE — confirmation only
      MySwal.fire({
        title: "Enable Login Access",
        html: `<p>Are you sure you want to <strong>enable</strong> login access for <strong>${record.name || "this user"}</strong>?</p>
               <p style="margin-top:10px;font-size:13px;color:#666;">This will allow the user to log into the system.</p>`,
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d9d9d9",
        confirmButtonText: "Enable Access",
        cancelButtonText: "Cancel",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await toggleLoginAccess(
              record._id,
              true,
              null,
              user?.data?._id || user?._id || null,
              user?.data?.name || user?.name || "Unknown"
            );
            MySwal.fire({
              title: "Enabled!",
              text: `Login access has been enabled for ${record.name || "this user"}.`,
              icon: "success",
              confirmButtonText: "OK",
              confirmButtonColor: "#28a745",
            });
            getUsers(); // Refresh
          } catch (error) {
            MySwal.fire({
              title: "Error",
              text: error.message || "Failed to enable login access",
              icon: "error",
            });
          }
        }
      });
    }
  };

  // View Login Access History
  const handleViewLoginHistory = async (record) => {
    setHistoryUserName(record.name || "User");
    setHistoryModalVisible(true);
    setHistoryLoading(true);
    try {
      const response = await getLoginAccessHistory(record._id);
      setHistoryData(response.data || []);
    } catch (error) {
      console.error("Error fetching login access history:", error);
      setHistoryData([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const columns = [
    {
      title: "Profile Pic",
      dataIndex: "profilePic",
      key: "profilePic",
      render: (profilePic, record) => {
        const imgUrl = record.profilePic
          ? `${base_path_img}${record.profilePic}`
          : "/placeholder.svg";
        return (
          <Image
            src={imgUrl}
            alt="Profile Picture"
            width={50}
            height={50}
            style={{
              borderRadius: "50%",
              objectFit: "cover",
            }}
            preview={{
              zIndex: 10000,
              src: imgUrl,
            }}
          />
        );
      },
      width: "110px",
    },
    {
      title: "User Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="userimgname">
          <Link to="#" className="userslist-img bg-img">
            <ImageWithBasePath alt="" src={record.img} />
          </Link>
          <div>
            <Link to="#">{text}</Link>
          </div>
          {/* {console.log(record,"record user.jsx")} */}
        </span>
      ),
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "EPF No",
      dataIndex: "user_name",
      sorter: (a, b) => a.phone.length - b.phone.length,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (role) => role?.roleName || "N/A", // Safely access 'roleName' or show 'N/A' if undefined
      sorter: (a, b) => a.role?.roleName.localeCompare(b.role?.roleName), // Sort by 'roleName'
    },
    {
      title: "Login Access",
      dataIndex: "loginAccess",
      key: "loginAccess",
      width: "170px",
      render: (loginAccess, record) => {
        const isEnabled = loginAccess !== false;
        return (
          <div style={{ textAlign: "center" }}>
            <div style={{ marginBottom: "6px" }}>
              <Tag
                color={isEnabled ? "success" : "error"}
                style={{
                  fontSize: "13px",
                  padding: "2px 12px",
                  borderRadius: "12px",
                  fontWeight: 500,
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: isEnabled ? "#52c41a" : "#ff4d4f",
                    marginRight: "6px",
                  }}
                />
                {isEnabled ? "Enabled" : "Disabled"}
              </Tag>
            </div>
            <Button
              size="small"
              type={isEnabled ? "default" : "primary"}
              danger={isEnabled}
              onClick={() => handleToggleLoginAccess(record)}
              style={{
                fontSize: "12px",
                borderRadius: "4px",
                padding: "0 12px",
                height: "26px",
              }}
            >
              {isEnabled ? "Disable" : "Enable"}
            </Button>
          </div>
        );
      },
      sorter: (a, b) => {
        const aVal = a.loginAccess !== false ? 1 : 0;
        const bVal = b.loginAccess !== false ? 1 : 0;
        return aVal - bVal;
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            {/* View Button */}
            <Link
              className={`me-2 p-2 ${user?.permissions && hasPermission(user.permissions, "User Management", "Users", "view")
                ? ''
                : 'disabled'
                }`}
              to="#"
              onClick={() => {
                if (user?.permissions && hasPermission(user.permissions, "User Management", "Users", "view")) {
                  handleViewUser(record);
                }
              }}
              title={
                !(user?.permissions && hasPermission(user.permissions, "User Management", "Users", "view"))
                  ? "You don't have permission to view users"
                  : "View user details"
              }
            >
              <i
                data-feather="eye"
                className="feather feather-eye action-eye"
              ></i>
            </Link>

            {/* Login Access History Button */}
            <Link
              className="me-2 p-2"
              to="#"
              onClick={() => handleViewLoginHistory(record)}
              title="View Login Access History"
              style={{ color: "#1890ff" }}
            >
              <i
                data-feather="clock"
                className="feather feather-clock"
              ></i>
            </Link>

            {/* Edit Button - Combined with existing hasJobRight check */}
            {
              <Link
                className={`me-2 p-2 ${user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "User Management",
                    "Users",
                    "edit"
                  )
                  ? ""
                  : "disabled"
                  }`}
                onClick={() => {
                  if (
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "User Management",
                      "Users",
                      "edit"
                    )
                  ) {
                    handleUpdateUser(record);
                  }
                }}
                title={
                  !(
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "User Management",
                      "Users",
                      "edit"
                    )
                  )
                    ? "You don't have permission to edit users"
                    : "Edit user"
                }
              >
                <i data-feather="edit" className="feather-edit"></i>
              </Link>
            }

            {/* Delete Button - Combined with existing hasJobRight check */}
            {
              <Link
                className={`confirm-text p-2 ${user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "User Management",
                    "Users",
                    "delete"
                  )
                  ? ""
                  : "disabled"
                  }`}
                to="#"
                onClick={() => {
                  if (
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "User Management",
                      "Users",
                      "delete"
                    )
                  ) {
                    showConfirmationAlert(record);
                  }
                }}
                title={
                  !(
                    user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "User Management",
                      "Users",
                      "delete"
                    )
                  )
                    ? "You don't have permission to delete users"
                    : "Delete user"
                }
              >
                <i data-feather="trash-2" className="feather-trash-2"></i>
              </Link>
            }
          </div>
        </td>
      ),
    },
  ];
  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        deleteUserData(record._id);
      } else {
        MySwal.close();
      }
    });
  };

  const openAddUser = () => {
    setOpenModal(true);
  };

  const closeAddUser = () => {
    setOpenModal(false);
  };
  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    filterUsers(searchValue); // Call filter function with the updated search value
  };
  const filterUsers = (searchTerm) => {
    if (!searchTerm.trim()) {
      setFilteredUsers(users);
      return;
    }

    const lowerCaseSearch = searchTerm.toLowerCase();
    const filtered = users.filter((user) => {
      const matchesName = user?.name && typeof user.name === 'string'
        ? user.name.toLowerCase().includes(lowerCaseSearch)
        : false;
      const matchesEmail = user?.user_name && typeof user.user_name === 'string'
        ? user.user_name.toLowerCase().includes(lowerCaseSearch)
        : false;

      return matchesName || matchesEmail;
    });

    setFilteredUsers(filtered);
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 };
    setPagination(newPagination);
    setPageSizeModalVisible(false);
  };

  // Login Access History table columns
  const historyColumns = [
    {
      title: "Status",
      dataIndex: "action",
      key: "action",
      width: "120px",
      render: (action) => (
        <Tag
          color={action === "ENABLED" ? "success" : "error"}
          style={{ fontWeight: 500, fontSize: "12px" }}
        >
          <span
            style={{
              display: "inline-block",
              width: "7px",
              height: "7px",
              borderRadius: "50%",
              backgroundColor: action === "ENABLED" ? "#52c41a" : "#ff4d4f",
              marginRight: "5px",
            }}
          />
          {action === "ENABLED" ? "Enabled" : "Disabled"}
        </Tag>
      ),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (reason) => reason || "\u2014",
    },
    {
      title: "Performed By",
      dataIndex: "performedByName",
      key: "performedByName",
      width: "150px",
      render: (name) => name || "System",
    },
    {
      title: "Date & Time",
      dataIndex: "dateTime",
      key: "dateTime",
      width: "180px",
      render: (dateTime) => {
        if (!dateTime) return "\u2014";
        const d = new Date(dateTime);
        return d.toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
      },
    },
  ];

  return (
    <div>
      <div className="page-wrapper-lt">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="header-leave-container ">
                <div>
                  <ArrowLeft size={32} />
                </div>

                <div className="page-title">
                  <h4>User List </h4>
                  <h6>Manage Your Users </h6>
                </div>
              </div>
              <div className="page-btn">
                <Link
                  to=""
                  className={`btn btn-added ${user?.permissions &&
                    hasPermission(
                      user.permissions,
                      "User Management",
                      "Users",
                      "create"
                    )
                    ? ""
                    : "disabled"
                    }`}
                  onClick={() => {
                    if (
                      user?.permissions &&
                      hasPermission(
                        user.permissions,
                        "User Management",
                        "Users",
                        "create"
                      )
                    ) {
                      openAddUser();
                    }
                  }}
                  title={
                    !(
                      user?.permissions &&
                      hasPermission(
                        user.permissions,
                        "User Management",
                        "Users",
                        "create"
                      )
                    )
                      ? "You don't have permission to add users"
                      : "Add new user"
                  }
                >
                  <PlusCircle className="me-2" />
                  Add New
                </Link>
              </div>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card-grid">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      value={search}
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      onChange={handleSearchChange}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              {/* /Filter */}

              {/* /Filter */}
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={filteredUsers.length > 0 ? filteredUsers : users}
                  loading={loading}
                  pagination={{
                    current: pagination.current,
                    total: filteredUsers.length,
                    pageSizeOptions: ["5", "10", "20", "50"],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddUsers open={openModal} onClose={closeAddUser} />
      <EditUser
        open={openEdit}
        onClose={handleClose}
        userId={updateUser?._id}
      />
      <ViewUser
        open={openView}
        onClose={handleCloseView}
        userId={viewUserId}
      />
      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button
            key="cancel"
            className="btn btn-cancel"
            onClick={() => setPageSizeModalVisible(false)}
          >
            Cancel
          </button>,
          <button
            key="submit"
            className="btn btn-submit"
            onClick={handlePageSizeChange}
          >
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select
            style={{ width: "100%" }}
            value={tempPageSize}
            onChange={(value) => setTempPageSize(value)}
          >
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>

      {/* Login Access History Modal */}
      <Modal
        title={
          <span style={{ fontSize: "16px", fontWeight: 600 }}>
            Login Access History — {historyUserName}
          </span>
        }
        open={historyModalVisible}
        onCancel={() => {
          setHistoryModalVisible(false);
          setHistoryData([]);
          setHistoryUserName("");
        }}
        footer={[
          <Button
            key="close"
            onClick={() => {
              setHistoryModalVisible(false);
              setHistoryData([]);
              setHistoryUserName("");
            }}
          >
            Close
          </Button>,
        ]}
        width={750}
      >
        {historyLoading ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <Spin size="large" />
            <p style={{ marginTop: "12px", color: "#999" }}>Loading history...</p>
          </div>
        ) : historyData.length === 0 ? (
          <Empty
            description="No login access history found"
            style={{ padding: "40px 0" }}
          />
        ) : (
          <Table
            columns={historyColumns}
            dataSource={historyData}
            rowKey={(record) => record._id}
            pagination={{ pageSize: 10, showSizeChanger: false }}
            size="small"
            bordered
          />
        )}
      </Modal>
    </div>
  );
};

export default Users;
